<template>
  <OrgTreeMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
